// const { baseURL } = require('@/config')
import request from '@/utils/request'
// import qs from 'qs'

/**
 *  根据 id 查询服务详情
 * @param id 
 * @returns 
 */
export function queryServiceInfo(id) {
    return request({
      url: '/api/wtbuService/queryServiceInfo?id=' +id,
      head: 'application/json;charset=UTF-8',
      method: 'get',
    })
} 
/**
 * 收藏和取消收藏
 * @returns 
 */
export function followService(id){
  return request({
    url:'/api/wtbuService/followService?serviceId='+id,
    head: 'application/json;charset=UTF-8',
    method: 'get',
  })
}

//
/**
 *  查询是否已收藏 1 已收藏 0 未收藏
 * @param {*} id 
 * @returns 
 */
export function queryServiceIsFollow(id){
    return request({
      url:'/api/wtbuService/queryIsFollow?serviceId='+id,
      head: 'application/json;charset=UTF-8',
      method: 'get',
    })
  }

// 获取移动门户token
  export function queryYDMHtoken(id) {
    return request({
      url: '/token/queryYDMHtoken?userId=' +id,
      head: 'application/json;charset=UTF-8',
      method: 'get',
    })
} 

// 访问次数记录
export function getCount(data){
  return request({
    url:'/api/wtbuService/getCount?serviceId='+data,
    head: 'application/json;charset=UTF-8',
    method: 'GET',
  })
}
//给微信发送消息
export function sendMsg(data){
  return request({
    url:'/api/wtbuService/sendMsg',
    head: 'application/json;charset=UTF-8',
    data,
    method: 'POST',
  })
}
// 通过serviceRunId获取serviceRun数据
export function getByServiceRunId(id) {
  return request({
    url: '/api/wtbuService/getByServiceRunId?id=' +id,
    head: 'application/json;charset=UTF-8',
    method: 'get',
  })
} 